/**
 * H9 — Footer link columns + compact accordion
 * Figma RedisignHomePage `1:1870` / compact `1:1952`
 */
import type { RouteLocationRaw } from 'vue-router'
import {
  PRIVACY_POLICY_ROUTE,
  TERMS_OF_SERVICE_ROUTE,
} from '@/router/routes'

export interface FairHomeV2FooterLink {
  id: string
  href?: string
  to?: RouteLocationRaw
  external?: boolean
}

export interface FairHomeV2FooterSection {
  id: string
  links: FairHomeV2FooterLink[]
  /** Horizontal link row on desktop (Social media) */
  layout?: 'column' | 'row'
}

export const FAIR_HOME_V2_FOOTER_COPYRIGHT_YEAR = 2026

export const FAIR_HOME_V2_FOOTER_SECTIONS: FairHomeV2FooterSection[] = [
  {
    id: 'about_us',
    links: [
      { id: 'about_fair' },
      { id: 'how_ai' },
      { id: 'press' },
      { id: 'contact' },
    ],
  },
  {
    id: 'for_business',
    links: [{ id: 'partnership' }],
  },
  {
    id: 'help_legal',
    links: [
      { id: 'help_center' },
      { id: 'privacy', to: PRIVACY_POLICY_ROUTE },
      { id: 'cookies' },
      { id: 'terms', to: TERMS_OF_SERVICE_ROUTE },
    ],
  },
  {
    id: 'social',
    layout: 'row',
    links: [
      {
        id: 'instagram',
        href: 'https://www.instagram.com/',
        external: true,
      },
      {
        id: 'tiktok',
        href: 'https://www.tiktok.com/',
        external: true,
      },
    ],
  },
]

export function isFairHomeV2FooterSocialSection(
  section: FairHomeV2FooterSection,
): boolean {
  return section.id === 'social'
}
